import type { Analytics } from '@cowbell/data/analytics';

import { getEnvironment } from '../../api/AuthService';
import { ENVIRONMENTS } from '../../types/common/env.dto';
import { getPlatformRegion } from '../../utils/app.utils';
import { configLogger } from '../loggers';

/**
 * A constant representing a redacted field identifier.
 * This is used to mark fields that should be redacted in logs or screen replay in LOGROCKET.
 */
export const REDACTED_FIELD = 'cb_redacted_field';

const APP_ID_PREFIX = 'i0bntq';
const DOM_OPTIONS = {
  inputSanitizer: 'lipsum',
  privateClassNameBlocklist: [REDACTED_FIELD],
};

export const ANALYTICS_CONFIG_BY_ENVIRONMENT = {
  // dev environments
  [ENVIRONMENTS.DEV_ENV_ID]: {
    'en-US': { appId: `${APP_ID_PREFIX}/cowbell-development-us`, options: {} },
  },
  [ENVIRONMENTS.DEV_SPACE]: {
    'en-US': { appId: `${APP_ID_PREFIX}/cowbell-development-us`, options: {} },
  },

  // staging environments
  [ENVIRONMENTS.STAGING_ENV_ID]: {
    'en-US': { appId: `${APP_ID_PREFIX}/cowbell`, options: DOM_OPTIONS },
    'en-AU': {
      appId: `${APP_ID_PREFIX}/cowbell-au-staging`,
      options: DOM_OPTIONS,
    },
    'en-GB': {
      appId: `${APP_ID_PREFIX}/cowbell-uk-staging`,
      options: DOM_OPTIONS,
    },
  },

  // prod environments
  [ENVIRONMENTS.PROD_ENV_ID]: {
    'en-US': {
      appId: `${APP_ID_PREFIX}/cowbell-production-us`,
      options: DOM_OPTIONS,
    },
    'en-AU': {
      appId: `${APP_ID_PREFIX}/cowbell-production-au`,
      options: DOM_OPTIONS,
    },
    'en-GB': {
      appId: `${APP_ID_PREFIX}/cowbell-production-uk`,
      options: DOM_OPTIONS,
    },
  },
};

export async function initializeAnalytics(analytics: Analytics) {
  try {
    const { data: env } = await getEnvironment();
    const region = getPlatformRegion();
    const analyticsConfig =
      ANALYTICS_CONFIG_BY_ENVIRONMENT[env.envName][region];

    analytics.init(analyticsConfig.appId, analyticsConfig.options);
  } catch (error) {
    configLogger.error('Analytics failed to initialize', { error });
    throw error;
  }
}
